const api_config = {
          code: 'ke',     // 站点代码
            bserUrl: 'https://api.kilimall.com', // 正式环境
              special_url: 'https://image.kilimall.com/kenya',  // 正式环境
              javaApiUrl: 'https://gw.kilimall.com',
              expressApiUrl: 'https://gw.kiliexpress.com',
              KjavaApiUrl: 'https://j.api.kilimall.com',
              subJavaUrl: 'https://gw.kilimall.com',
              afterSaleUrl: 'https://api.api.kilimall.com',
              afterChatUrl: 'https://api.api.kilimall.com',
              apmUrl: 'https://apm.api.kilitest.com',
              liteUrl: 'https://mall-api.kilimall.ke',
              mobilePhpUrl: 'https://mobile.kilimall.co.ke',
              searchUrl: 'https://search.api.kilimall.com'
}
export default api_config
